module.exports = __webpack_public_path__ + "media/images/page/card-link-img-869f43d0678448ada48bdecc143c6d92.jpg";